<template>
<div class="main" ref="main">
        <div class="content">
            <div style="height:200px"></div>
			<div class="designerDetail" >
                <h1 >设计师简介</h1>
                <h2 >&nbsp;&nbsp;&nbsp;&nbsp;{{designer.designerDetail}}</h2>
                <h1 >设计师风格</h1>
                <h2 >&nbsp;&nbsp;&nbsp;&nbsp;{{designer.designerStyle}}</h2>
            </div>
            <van-list
                v-model="loading"
                :finished="finished"
                :immediate-check="false"
                finished-text="没有更多了">
                <div class="caseList" v-for="(item,index) in designer.caseList" :key="index" @click="caseClick(item)">

                    <van-image radius="20px" :src="UPLOAD_FILE_PATH+item.caseFileUrl" alt=""/>
                    <div class="caseDesc">
                        <van-tag v-if="item.caseTypeName" size="large" round plain type="primary">{{item.caseTypeName}}</van-tag>
                        <van-tag v-if="item.houseType" size="large" round plain type="primary">{{item.houseTypeName}}</van-tag>
                        <van-tag v-if="item.style" size="large" round plain type="primary">{{item.houseStyleName}}</van-tag>
                        <h4>{{item.caseName}}</h4>
                    </div>


                </div>
            </van-list>
        </div>

        <div class="designer">
            <div class="top">
                <div class="designerList">
                    <van-row >
                        <div @click="designerClick()">
                            <van-col span="10">
                                <van-image radius="10px" :src="UPLOAD_FILE_PATH+designer.designerFileUrl" alt="" />
                            </van-col>
                            <van-col span="14" >
                                <div class="designerFont">
                                    <p style="font-size: 20px;color: #323232;">{{ designer.designerName }}</p>
                                    <img width="15px" :src="wuxing" alt="">
                                    <img width="15px" :src="wuxing" alt="">
                                    <img width="15px" :src="wuxing" alt="">
                                    <img width="15px" :src="wuxing" alt="">
                                    <img width="15px" :src="wuxing" alt="">
                                    五星推荐
                                    <p>{{ designer.designerTypeName }}</p>
                                    <p>{{ designer.designerExperienceName }}</p>
                                    <van-button plain type="primary" @click="designerClick()">预约设计</van-button>
                                </div>
                            </van-col>
                        </div>
                    </van-row>
                    <div style="height: 10px;"></div>
                </div>
            </div>
        </div>


        <!-- 预约弹窗 -->
        <van-popup v-model="reservationShow" closeable position="bottom" :style="{ height: '40%' }" round >
            <van-form @submit="reservationSubmit">
                <div class="mytitle" @click="titleClick()">
                    <h4>预约设计师 {{designer.designerName}}</h4>
                </div>
                <van-field
                    v-model="reservationData.userName"
                    name="您的称呼"
                    label="您的称呼"
                    placeholder="您的称呼"
                />
                <van-field
                    v-model="reservationData.phone"
                    name="手机号"
                    label="手机号"
                    placeholder="手机号"
                />
                <div style="margin: 16px;">
                    <van-button round block type="info" native-type="submit">提交</van-button>
                </div>
            </van-form>
        </van-popup>
    </div>

</template>
<script>
import wuxing from '../../../icon/wuxing.png'
import { Notify } from 'vant';
import { insertReservation,getDesigner,getCaseDetailList, UPLOAD_FILE_PATH} from "@/https/http.js";

import { ImagePreview } from 'vant';
export default {
    data(){
        return{
            UPLOAD_FILE_PATH:UPLOAD_FILE_PATH,
            loading:false,
            finished:true,
            reservationShow:false,
            wuxing,
            designer:{},
            reservationData:{
                userName:"",
                phone:"",
                remark:"",
                rentId:JSON.parse(localStorage.getItem("rent")).rentId,
            }
        }
    },
    created(){
        this.queryDesigner();
    },
    methods:{
        caseClick(item){
            if(item.caseUrl){
                window.open(item.caseUrl)
            }else{
                getCaseDetailList(item).then(res=>{
                    if(res.data&&res.data.length>0){
                        let caseDetailList = []
                        res.data.forEach(item => {
                            caseDetailList.push(this.UPLOAD_FILE_PATH + item) 
                        });
                        ImagePreview({
                            images:caseDetailList,
                            showIndex:true,
                            loop:false,
                            startPosition:0
                        })
                    }
                })
            }
        },
        designerClick(){
            this.reservationShow = true
        },
        queryDesigner(){
            let designerId = this.$route.query.designerId
            getDesigner({"designerId":designerId}).then(res=>{
                this.designer = res.data
            })
        },
        reservationSubmit(){
            if(""==this.reservationData.phone){
                Notify({
                    message: '请填写您的联系方式',
                    duration: 1000,
                });
            }else{
                this.remark = "预约活动-活动ID:"+this.$route.query.activityId
                insertReservation(this.reservationData).then(res=>{
                    Notify({
                        type: 'success',
                        message: '预约成功，稍后会有工作人员与您联系',
                        duration: 1000,
                    });
                    this.reservationShow=false
                })
            }
        },
    }


}
</script>

<style lang="less" scoped>
.top{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    font-size: 16px;
}
.van-image{
    margin-left: 10px;
    margin-top: 10px;
}
.designerList{
    background-color:#F5F6F7;
    margin: 10px;
    border-radius:18px;
}
.designerFont{
    margin-left: 10px;
    margin-top: 30px;
    color: #7c7c7c;
    font-size: 14px;
    line-height: 30px;
}
.designerDetail{
    background-color:#F5F6F7;
    margin: 10px;
    border-radius:18px;
    h1{
        margin-left: 20px;
        margin-top: 20px;
        font-size: 18px;
        color: #323232;;
    }
    h2{
        margin-left: 30px;
        margin-right: 30px;
        font-size: 14px;
        color: #7c7c7c;
    }
}
.main{
    width: 100%;
    height: 95vh;
    overflow-y: scroll;
}
.content{
    margin-top: 10%;
}
.caseList{
    background-color:#F5F6F7;
    margin: 10px;
    border-radius:18px;
}
.caseDesc{
    text-align: center;
}
.mytitle {
    text-align: center;
    font-size: 16px;
    margin-top: 20px;
    position: relative;
    height: 50px;
    span {
        width: 50%;
        height: 2px;
        background-color: #ccc;
        display: inline-block;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
    h3 {
        width: 30%;
        background-color: #fff;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
}
</style>